import { Typography } from '@mui/material';
import { InteractiveModal } from 'components/Modals/InteractiveModal/BaseModal';
import DeviceHandler from 'handlers/device.handler';
import { type Device } from 'types/device.types';
import { useTranslation } from 'react-i18next';

export {};

/**
 *
 * The delete modal is a modal that is used to delete an Asset.
 */

interface Props {
  open: boolean;
  deviceData: Device;
  handleAbort: () => void;
}

export const DeviceUnlinkModal = ({ open, deviceData, handleAbort }: Props) => {
  const { t } = useTranslation();
  const deviceHandler = new DeviceHandler();
  const title = 'Confirm Device Unlinking';
  return (
    <InteractiveModal
      initialState={open}
      title={title}
      handleAbort={handleAbort}
      SuccessButtonProps={{
        onClick: async () => {
          await deviceHandler.updateDevice(deviceData.deviceId, {
            assetId: null,
          });
          handleAbort();
        },
        disabled: false,
        label: t('confirm_unlinking'),
      }}
      ModalContentProps={{
        gridItemProps: {
          lg: 12,
        },
      }}
    >
      <Typography key="blurb-1" variant="medium">
        {t('are_you_sure_you_want_to_unlink')} {deviceData.deviceId}{' '}
        {t('from_asset')}
        {deviceData.assetId}
      </Typography>
      <Typography key="blurb-2" variant="medium"></Typography>
    </InteractiveModal>
  );
};
